import { render } from "./RenameDPSubCategories.vue?vue&type=template&id=d78ac108&scoped=true&ts=true"
import script from "./RenameDPSubCategories.vue?vue&type=script&lang=ts"
export * from "./RenameDPSubCategories.vue?vue&type=script&lang=ts"

import "./RenameDPSubCategories.vue?vue&type=style&index=0&id=d78ac108&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d78ac108"]])

export default __exports__